import { apiRequest } from "../util/apiUtils";

export const stepsList = async (params) => {
  try {
    const res = await apiRequest("get", `steps/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const saveStep = async (payload) => {
  try {
    const res = await apiRequest("patch", `media/save-step`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const defaultTemplate = async (params) => {
  try {
    const res = await apiRequest("get", `template/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
